// export interface ReportFilter {
//
// }

export enum ReportGroupBy {
  Day = '0',
  Hour = '1',
  Source = '2',
  Called = '3',
  Queue = '4',
  Campaign = '5',
  Service = '6',
  Group = '7',
  Agent = '8',
}
export const QueueVoiceManager = [1, 2, 3, 8, 9];
export const SourceArray = [
  { id: '-1', text: 'Tất cả' },
  { id: '0', text: 'INBOUND' },
  { id: '1', text: 'OUTBOUND' },
];

export const ReportGroupByArray = [
  { id: ReportGroupBy.Day, text: 'ngày' },
  { id: ReportGroupBy.Hour, text: 'giờ' },
  { id: ReportGroupBy.Source, text: 'nguồn' },
  { id: ReportGroupBy.Called, text: 'đầu số' },
  { id: ReportGroupBy.Queue, text: 'hàng đợi' },
  { id: ReportGroupBy.Campaign, text: 'chiến dịch' },
  // { id: ReportGroupBy.Service, text: "dịch vụ" },
  { id: ReportGroupBy.Group, text: 'bộ phận' },
  { id: ReportGroupBy.Agent, text: 'chuyên viên' },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/filter/filter.const.ts